import React from 'react';
import { Navigate } from 'react-router-dom';
import Icon from './Icon';
import { usePagePermissions, PAGE_LABEL } from '../hooks/usePagePermissions';

const PageGate = ({ page, children }) => {
  const { loaded, hasPage, isSuperAdmin } = usePagePermissions();

  if (!loaded) {
    return <div className="text-tx3 text-sm" style={{ padding: 'var(--s8)' }}>Loading…</div>;
  }

  if (!hasPage(page)) {
    return (
      <div style={{ padding: 'var(--s8)' }}>
        <div className="card" style={{ width: '100%', maxWidth: 480, textAlign: 'center', padding: 'var(--s8)' }}>
          <div className="empty-icon" style={{ margin: '0 auto var(--s4)' }}>
            <Icon name="shield" size={26} />
          </div>
          <h2 style={{ fontSize: 22, fontWeight: 800, color: 'var(--tx1)', marginBottom: 'var(--s2)' }}>
            No access to {PAGE_LABEL[page] || page}
          </h2>
          <p style={{ color: 'var(--tx2)', fontSize: 14, lineHeight: 1.6 }}>
            Your role doesn't include this page. Ask the super admin (stanford@coynitt.ca) to grant access in Settings → Users.
          </p>
          {isSuperAdmin && (
            <p style={{ color: 'var(--tx3)', fontSize: 12, marginTop: 'var(--s4)' }}>
              (You're flagged as super admin — if you're seeing this, refresh the page; permissions just changed.)
            </p>
          )}
          <Navigate to="/" replace />
        </div>
      </div>
    );
  }

  return children;
};

export default PageGate;
